const settingsLink = document.querySelector(".cookie-settings-link");
if (settingsLink) {
    settingsLink.addEventListener("click", function (e) {
        e.preventDefault();
        // Try calling the privacy banner
        if (privacyBanner?.showPreferences) {
            privacyBanner?.showPreferences();
        } else {
            // Fallback
            const prefs = document.getElementById("shopify-pc__prefs");
            if (prefs) {
            prefs.style.setProperty("display", "block", "important");
            }
        }
    });
}